/**
 * @generated SignedSource<<caae8901ea12ee66621c5508c2e36ccc>>
 * @relayHash d336d39f02c9f3d4f2c1e23a480d06ca
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID d336d39f02c9f3d4f2c1e23a480d06ca

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redirectUrl"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "redirectUrl",
        "variableName": "redirectUrl"
      }
    ],
    "kind": "ScalarField",
    "name": "authorizationUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QAuthorizationUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QAuthorizationUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d336d39f02c9f3d4f2c1e23a480d06ca",
    "metadata": {},
    "name": "QAuthorizationUrlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d20d034ddd392ed098cac0b9338e6003";

export default node;
